<template>
  <div class="bankid-start-container">
    <div class="bankid-start-buttons">
      <FriedButton
        data-external="start-sign-with-mobile-bankid"
        :button-type="ButtonType.Secondary"
        :loading="qrIsLoading"
        @click="handleSetQR"
      >
        <template #leftIcon>
          <BankIdLogo />
        </template>
        {{ $t('mobile-bankid') }}
      </FriedButton>
      <FriedButton
        data-external="bankid-other-device-button"
        :loading="sameDeviceIsLoading"
        :button-type="ButtonType.Secondary"
        @click="handleSetSameDevice"
      >
        <template #leftIcon>
          <BankIdLogo />
        </template>
        {{ $t('bankid-on-other-device') }}
      </FriedButton>
    </div>
  </div>
</template>

<script lang="ts">
import { ButtonType } from '@getaccept/fried-tofu';
import type { PropType } from 'vue';
import { computed, ref, defineComponent } from 'vue';
import BankIdLogo from '../../../assets/bankid.svg';
import type { BankId } from '../../../types/bankid';
import { BankIdSigningType } from '../../../types/enums/bankid-se';

export default defineComponent({
  components: {
    BankIdLogo,
  },
  props: {
    bankId: {
      type: Object as PropType<BankId>,
      required: true,
    },
  },
  emits: ['setQR', 'setSameDevice'],
  setup(props, { emit }) {
    const type = ref<BankIdSigningType>(BankIdSigningType.None);

    const handleSetQR = () => {
      type.value = BankIdSigningType.QR;
      emit('setQR');
    };

    const handleSetSameDevice = () => {
      type.value = BankIdSigningType.SameDevice;
      emit('setSameDevice');
    };

    const qrIsLoading = computed(
      () => props.bankId.isLoading && type.value === BankIdSigningType.QR
    );

    const sameDeviceIsLoading = computed(
      () => props.bankId.isLoading && type.value === BankIdSigningType.SameDevice
    );

    return {
      ButtonType,
      type,
      handleSetQR,
      handleSetSameDevice,
      qrIsLoading,
      sameDeviceIsLoading,
    };
  },
});
</script>

<style lang="scss" scoped>
.bankid-start-container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-150);

  .bankid-start-buttons {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-50);
  }
}
</style>
